import React from 'react';
import {useDispatch} from "react-redux";
import {BadgeView} from "../../list/BadgeView";

const SelectedUserBadgeView = ({users, reducer}) => {
    const dispatch = useDispatch();

    const handlerDeleteUser = (user) => {
        const excluded = users.filter(selected => selected.id !== user.id);
        dispatch(reducer([...excluded]))
    }

    return (
        <>
            {reducer
                ? <BadgeView data={users} deleteItem={handlerDeleteUser}/>
                : <BadgeView data={users}/>
            }
        </>
    );
};

export default SelectedUserBadgeView;